<div id="home">
    <div class="container">
        
        <div class="row home-no-margin-bottom">
            <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                                
                <search-box-title></search-box-title>

                <search-box geolocate-on-map-ready="::ctrl.geolocateOnMapReady"></search-box>
            </div>
        </div>

        <p></p>
        <p></p>
        <map></map>
        
        <shop-list-title></shop-list-title>
        
        <shop-list></shop-list>
        
        <city-district-select></city-district-select>

        <!-- <shop-highlights></shop-highlights> -->
    </div>
</div>